// extracted by mini-css-extract-plugin
export var container = "_2c-0";